export const SITE_PHONE_DISPLAY = '1800 003 527';
export const SITE_PHONE_TEL = 'tel:+611800003527';
export const SITE_PHONE_SCHEMA = '+611800003527';
export const BUSINESS_PHONE_DISPLAY = '02 7238 6211';
export const BUSINESS_PHONE_TEL = 'tel:+61272386211';
export const BUSINESS_PHONE_SCHEMA = '+61272386211';

export const LEGAL_CONSENT_DOCUMENT_PATH = '/legal/flash-funding-consent.v2026.05.28.pdf';

export const COMPLIANCE_DISCLOSURE_TEXT = 'Flash Funding is a trading name of Flash Funding Group Pty Ltd ABN 17 698 240 578. Flash Funding Group Pty Ltd is an Authorised Credit Representative 578970 of Australian Credit Licence 414426, AFAS Group Pty Ltd ABN 12 134 138 686.';

export const FOOTER_COPYRIGHT_TEXT = '© 2026 Flash Funding Group Pty Ltd trading as Flash Funding. All rights reserved. ABN: 17 698 240 578';

export const CANONICAL_BASE_URL = 'https://www.flashfunding.loan';

export const PORTAL_LINKS = {
  GENERIC: 'https://portal.flashfunding.loan',
  CAR: 'https://portal.flashfunding.loan/car-loans/quick-quote',
  PERSONAL: 'https://portal.flashfunding.loan/personal-loans/quick-quote',
  LEISURE: 'https://portal.flashfunding.loan/leisure-finance/quick-quote',
  COMMERCIAL: 'https://portal.flashfunding.loan/commercial-finance/quick-quote',
  BUSINESS: 'https://portal.flashfunding.loan/business-loans/quick-quote',
};

export function buildPortalTrackingUrl(baseUrl, product, content = 'finance_finder') {
  const url = new URL(baseUrl);
  url.searchParams.set('utm_source', 'flashfunding');
  url.searchParams.set('utm_medium', 'website');
  url.searchParams.set('utm_campaign', `portal_${product}`);
  url.searchParams.set('utm_content', content);
  return url.toString();
}

export const BUSINESS_LOCALITY = 'Gledswood Hills NSW 2557';

export const TRUST_FACTS = [
  { label: 'Credit representative', value: 'ACR 578970' },
  { label: 'Licensee', value: 'ACL 414426 (AFAS Group)' },
  { label: 'Reviews', value: 'See our Google reviews', path: '/reviews' },
  { label: 'Service area', value: 'Australia-wide' },
];
